import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import SelectEntities from '../../components/select-entities';
import Modal from '../../components/Render/Modal/Modal';
import TextSection from '../../components/ListEntity/TextSection';
import LayoutSection from '../../components/layout-section';
import HomeForm from '../../forms/home/HomeForm';
import * as ActionText from '../../redux/modules/text';
import {IMAGES_REPO} from '../../config';

class General extends PureComponent {
  state = {isOpenHome: false, isOpenTeam: false};

  getData() {
    this.props.getText('home');
  }

  componentWillMount() {
    this.getData();
  }

  removeTeamMember(info) {
    if (info.id > 0) {
      const {getTeam, delTeam} = this.props;
      delTeam(info.id).then(() => {
        getTeam();
      });
    }
  }

  toggleOpenHomeModal(data = {}) {
    this.setState({isOpenHome: !this.state.isOpenHome, data});
  }

  render() {
    const {home} = this.props;
    console.log(`${IMAGES_REPO}${home.values.photo1}`);
    return (
      <div className="contacts-container container">

        <div>
          <h1>Home</h1>
        </div>

        <LayoutSection
          isFetching={home.isFetching}
          title="">
          <TextSection
            editAction={() => {
              this.toggleOpenHomeModal(home.values);
            }}>
            <div className="home-header">
              <img className="img" src={`${IMAGES_REPO}${home.values.photo1}`}/>
              <div className="text" dangerouslySetInnerHTML={{__html: home.values.body}}></div>
            </div>
          </TextSection>
        </LayoutSection>

        <div>
          <h1>Next Events</h1>
          <SelectEntities
            section="next-news"
            entity="New"
            list={home.values.next_news}/>
        </div>

        <div>
          <h1>Last Events</h1>
          <SelectEntities
            section="last-news"
            entity="New"
            list={home.values.last_news}/>
        </div>

        <div>
          <h1>News</h1>
          <SelectEntities
            section="articles"
            entity="Article"
            list={home.values.articles}/>
        </div>

        <div className="contacts-container__modal">
          <Modal
            toogle={this.toggleOpenHomeModal.bind(this)}
            isOpen={this.state.isOpenHome}>
            <HomeForm
              defaultValues={this.state.data}
              close={this.toggleOpenHomeModal.bind(this)}/>
          </Modal>

        </div>
      </div>
    );
  }
}

General.propTypes = {};
General.defaultProps = {};

export default connect(
  (state) => {
    return {
      home: state.text
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getText: ActionText.get
      }, dispatch);
  }
)(General);



// WEBPACK FOOTER //
// ./src/containers/home/Home.js